<div>
  <div>{{'analysis.relevantAnalysisTitle' | transloco}}</div>
  <mat-button-toggle-group
    class="togglebox"
    name="RelevantCalculations"
    aria-label="Relevant Calculations"
    [hideMultipleSelectionIndicator]="true"
    multiple
  >
    <mat-button-toggle [checked]="relevantAnalysisTypes.recyclingRelevant" (click)="ButtonClicked(relevantAnalysisType.Recyclability)">{{'analysis.recyclabilityAnalysis.title'|transloco}}</mat-button-toggle>
    <mat-button-toggle [checked]="relevantAnalysisTypes.lcaRelevant" (click)="ButtonClicked(relevantAnalysisType.Lifecycle)">{{'analysis.lifecycleAnalysis.title'|transloco}}</mat-button-toggle>
    <mat-button-toggle [checked]="relevantAnalysisTypes.ccRelevant" (click)="ButtonClicked(relevantAnalysisType.CostCalculation)">{{'analysis.expenseCalculation.title'|transloco}}</mat-button-toggle>
  </mat-button-toggle-group>
</div>
